import axios from 'axios'

class ImportacaoApiClient {

    async buscarNumeroProcesso(processo) {
        return await axios.post('/compra-direta/api/v1/comprador/compras-diretas/importacao', processo)
    }

    async reimportarProcesso(processo) {
        return await axios.post('/compra-direta/api/v1/comprador/compras-diretas/reimportacao', {processo})
    }

}

export default new ImportacaoApiClient()
